// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
/* 自定义样式 */
.van-field__label[data-v-b4622b00] {
  color: #333;
  font-weight: 500;
}
.van-field__control[data-v-b4622b00] {
  color: #666;
}
.van-field__control[data-v-b4622b00]::-moz-placeholder {
  color: #ccc;
}
.van-field__control[data-v-b4622b00]::placeholder {
  color: #ccc;
}
[data-v-b4622b00] .van-cell {
  background-color: transparent;
}
[data-v-b4622b00] .van-field__control {
  text-align: right;
}
`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
